var $$ = $$ || {};

$$.OpenPopup = class OpenPopup {
	constructor (root) {
		this.root = root;

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_cacheNodes () {
		this.nodes = {

		};
	}

	_bindEvents () {
		this.root.on('click', (event) => {
			var button = $(event.currentTarget);

			$$.Popup.openPopup(button.data('popup'));
		});
	}

	_ready () {

	}
};
